// eslint-disable-next-line node/prefer-global/process
export default globalThis.process || { env: {} }
